import gql from 'graphql-tag';

export const deleteCommentQuery = gql`
  mutation deleteComment($commentId: String!) {
    deleteComment(commentId: $commentId)
  }
`;

const deleteComment = () => ({
  mutation: deleteCommentQuery,
  module: 'comments',
  buildVariables: ({ commentId }) => ({
    commentId
  })
});

export default deleteComment;